import { useEffect } from "react";
import HeaderStyleTwo from "../Shared/HeaderStyleTwo";
import Footer from "../Shared/Footer";
import Facts from "../Shared/Facts";
import { LionPlayer } from 'lion-player';
import 'lion-player/dist/lion-skin.min.css';
const Videos = () => {
    useEffect(() => {
        runJQueryScripts();
    }, []);

    const runJQueryScripts = () => {
        let tag: any;
        let loadScript = function (src: string) {
            tag = document.createElement("script");
            tag.async = false;
            tag.src = src;
            document.getElementsByTagName("body")[0].appendChild(tag);
        };
        loadScript("../assets/js/jquery.js");
        loadScript("../assets/js/popper.min.js");
        loadScript("../assets/js/jquery-ui.js");
        loadScript("../assets/js/jquery.fancybox.js");
        loadScript("../assets/js/owl.js");
        loadScript("../assets/js/appear.js");
        loadScript("../assets/js/wow.js");
        loadScript("../assets/js/lazyload.js");
        loadScript("../assets/js/scrollbar.js");
        loadScript("../assets/js/script.js");
        return () => {
            document.getElementsByTagName("body")[0].removeChild(tag);
        }
    }
    return (
        <>
            <HeaderStyleTwo />
            <div className="ulockd-inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ulockd-icd-layer">
                                <ul className="list-inline ulockd-icd-sub-menu">
                                    <li><a style={{ color: '#25283a' }} href="/"> Home </a></li>
                                    <li><a style={{ color: '#25283a' }} href="#"><b> / </b></a></li>
                                    <li> <a href="//videos"> Videos</a> </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="news-section" style={{ paddingTop: 50, paddingBottom: 20 }}>

                <div className="auto-container">

                    <div className="title-box clearfix" style={{ marginBottom: 10 }}>
                        <div className="sec-title">
                            <div className="sub-title">Watch Our Videos</div>
                            {/* <h2>Latest Videos</h2> */}
                        </div>

                        {/* <div className="link"><a href="/" className="theme-btn btn-style-one"><span className="btn-title">All Videos</span></a></div> */}
                    </div>

                    <div className="row clearfix">
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="0ms">
                                {/* <div className="image-box">
                                    <figure className="image"><a href="blog-single.html"><img className="lazy-image" src="images/resource/image-spacer-for-validation.png" data-src="images/resource/blog-image-1.jpg" alt="" /></a></figure>
                                </div> */}
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/free-grocery-for-widows-and-senior-citizen-complete-profile.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Free Grocery for Widows and Senior Citizen</h3>
                                </div>
                            </div>
                        </div>

                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/apna-rozgar-small-business-setups.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Apna Rozgar (Small Business Setups)</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/medical-support.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Free Medical Support</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/sadqa-e-jariya welfare-mart.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Sasta Rashan Program</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/sasta-rashan-program.mp4'} />
                                        </div>
                                    </div>
                                    <h3>SJ Welfare Mart</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/free-technical-training-center.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Free Technical Training Center Initiative </h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/eid-preparation-highlights.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Eid Preparation Highlights </h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/women-empowerment.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Women Empowerment </h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/apna-rozgar updates.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Apna Rozgar Updates</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/ration-distribution-updates.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Ration Distribution Updates</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/30-Days-30-Rozgar-Ramadan-2022.mp4'} />
                                        </div>
                                    </div>
                                    <h3>30 Days 30 Rozgar (Ramadan 2022)</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/ration-distribution-updates-april-2023.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Ration Distribution Updates (April 2023)</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/sastay-fruits.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Sastay Fruits by SEJWF</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/SJ-Welfare-Mart.mp4'} />
                                        </div>
                                    </div>
                                    <h3>SJ Welfare Mart Updates</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/100-blankets-for-madrasa-students.mp4'} />
                                        </div>
                                    </div>
                                    <h3>100 Blankets for Madrasa Students (Multan)</h3>
                                </div>
                            </div>
                        </div>
                        {/* <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/darul-akhlaq.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Darul Akhlaq (Institution that teaches way of life) Initiative </h3>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="600ms">

                            <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/apna-rozgar-small-business-setups.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Apna Rozgar (Small Business Setups)</h3>
                                </div>
                            </div>
                        </div> */}
                           <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/clothes-for-orphsans.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Clothes for Orphans</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/free-food-at-civil-hospital1.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Free Food at Civil Hospital 1 (Karachi)</h3>
                                </div>
                            </div>
                        </div>
                        <div className="news-block col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-delay="300ms">
                                <div className="lower-content" style={{ padding: 5 }}>
                                    <div id="video_block_one">
                                        <div className="video-inner" style={{ padding: 5 }}>
                                            <LionPlayer sources={'../assets/video/free-food-at-civil-hospital.mp4'} />
                                        </div>
                                    </div>
                                    <h3>Free Food at Civil Hospital (Karachi)</h3>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            {/* <VolunteersBanner /> */}
            <Footer />
        </>
    );
};
export default Videos;
